import axios from 'axios';
import type { GroupedPermission, PermissionResponse, Privilege } from '../types/Permission';
import { groupPrivilegesByType } from '../utils/permission';
import { baseUrl } from './base';

export async function getAllPermission(): Promise<GroupedPermission> {
  const res = await axios.request<PermissionResponse>({
    url: `${baseUrl.TERMINAL}/user-management/roles/privileges`,
    method: 'GET',
  });
  const grouped = groupPrivilegesByType(res.data.data.group);
  return grouped;
}

export async function getRolePermission(role: string): Promise<GroupedPermission> {
  const res = await axios.request<PermissionResponse>({
    url: `${baseUrl.TERMINAL}/user-management/roles/${role}`,
    method: 'GET',
  });
  const grouped = groupPrivilegesByType(res.data.data.group);
  return grouped;
}

export type PatchRolePermissionPayload = {
  role: string;
  privileges: Omit<Privilege, 'name'>[];
};

export async function patchRolePermission({ role, privileges }: PatchRolePermissionPayload): Promise<GroupedPermission> {
  const res = await axios.request({
    url: `${baseUrl.TERMINAL}/user-management/roles/${role}`,
    method: 'PATCH',
    data: {
      privileges,
    },
  });
  return res.data;
}

export async function createRolePermission(data: { privileges: Omit<Privilege, 'name'>[]; name: string }): Promise<GroupedPermission> {
  const res = await axios.request({
    url: `${baseUrl.TERMINAL}/user-management/roles`,
    method: 'POST',
    data,
  });
  return res.data;
}

// Generated by https://quicktype.io

export interface ClientRolesResponse {
  data: ClientRole[];
}

export interface ClientRole {
  slug: string;
  name: string;
}

export async function getRoles() {
  const resp = await axios.get<ClientRolesResponse>(`${baseUrl.TERMINAL}/user-management/roles`);
  return resp.data;
}

export async function getAllRoles() {
  const resp = await axios.get<ClientRolesResponse>(`${baseUrl.TERMINAL}/user-management/roles/all`);
  return resp.data;
}
